import React from 'react';
import s from './s.module.less';

interface Step {
    id: number;
    title: string;
}

interface StepIndicatorProps {
    steps: Step[];
    currentStep: number;
    onStepClick?: (step: number) => void;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep, onStepClick }) => {
    return (
        <div className={s.stepIndicatorWrap}>
            <div className={s.verticalSteps}>
                {steps.map((step, index) => {
                    const isCompleted = step.id < currentStep;
                    const isActive = step.id === currentStep;
                    const isLast = index === steps.length - 1;

                    let lineClass = '';
                    if (isActive) {
                        lineClass = s.active;
                    } else if (isCompleted) {
                        lineClass = s.completed;
                    }

                    return (
                        <div
                            key={step.id}
                            className={s.stepItem}
                            onClick={() => onStepClick?.(step.id)}
                        >
                            <div className={`${s.stepCircle} ${isCompleted ? s.completed : ''} ${isActive ? s.active : ''}`}>
                                {isCompleted && <div className={s.checkmark} />}
                                {isActive && <div className={s.activePoint} />}
                            </div>
                            <div className={`${s.stepTitle} ${isCompleted ? s.completed : ''} ${isActive ? s.active : ''}`}>
                                {step.title}
                            </div>
                            {!isLast && (
                                <div className={s.stepLine}>
                                    <div
                                        className={`${s.stepLineUpper} ${lineClass}`}
                                    />
                                    <div
                                        className={`${s.stepLineLower} ${lineClass}`}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default StepIndicator;
